// Handle OCR text modal functionality
document.addEventListener('turbo:load', () => {
  const modal = document.getElementById('ocr-text-modal');
  if (!modal) return;

  const loadingDiv = document.getElementById('ocr-text-loading');
  const contentTextarea = document.getElementById('ocr-text-content');
  const copyButton = document.getElementById('copy-ocr-text');
  const saveButton = document.getElementById('save-ocr-text');
  let currentAttachmentId = null;

  // When modal is about to be shown
  modal.addEventListener('show.bs.modal', async (event) => {
    const button = event.relatedTarget;
    currentAttachmentId = button.getAttribute('data-attachment-id');

    // Reset modal state
    loadingDiv.style.display = 'block';
    contentTextarea.style.display = 'none';
    contentTextarea.value = '';
    copyButton.style.display = 'none';
    saveButton.style.display = 'none';

    try {
      const response = await fetch(`/active_storage/attachments/${currentAttachmentId}/ocr_text`);

      if (response.ok) {
        const data = await response.json();

        if (data.content) {
          contentTextarea.value = data.content;
          loadingDiv.style.display = 'none';
          contentTextarea.style.display = 'block';
          copyButton.style.display = 'inline-block';
          saveButton.style.display = 'inline-block';
        } else {
          loadingDiv.innerHTML = `
            <div class="alert alert-info mb-0">
              <i class="fas fa-info-circle me-2"></i>
              No OCR text found for this document. The file may not have been processed yet or may not contain extractable text.
              <br><br>
              <a href="#" class="btn btn-sm btn-primary" id="run-ocr-btn">
                <i class="fas fa-sync-alt me-1"></i> Process with OCR
              </a>
            </div>
          `;
          const runOcrBtn = document.getElementById('run-ocr-btn');
          if (runOcrBtn) {
            runOcrBtn.addEventListener('click', async (e) => {
              e.preventDefault();
              runOcrBtn.disabled = true;
              runOcrBtn.innerHTML = '<i class="fas fa-spinner fa-spin me-1"></i> Processing...';
              try {
                const ocrResponse = await fetch(`/active_storage/attachments/${currentAttachmentId}/run_ocr`, {
                  method: 'POST',
                  headers: {
                    'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
                  }
                });
                if (ocrResponse.ok) {
                  runOcrBtn.innerHTML = '<i class="fas fa-check me-1"></i> OCR Queued!';
                  runOcrBtn.classList.remove('btn-primary');
                  runOcrBtn.classList.add('btn-success');
                } else {
                  throw new Error('Failed to queue OCR');
                }
              } catch (err) {
                console.error('Error running OCR:', err);
                runOcrBtn.innerHTML = '<i class="fas fa-exclamation-triangle me-1"></i> Failed';
                runOcrBtn.classList.remove('btn-primary');
                runOcrBtn.classList.add('btn-danger');
              }
            });
          }
        }
      } else {
        throw new Error('Failed to fetch OCR text');
      }
    } catch (error) {
      console.error('Error fetching OCR text:', error);
      loadingDiv.innerHTML = `
        <div class="alert alert-danger mb-0">
          <i class="fas fa-exclamation-triangle me-2"></i>
          Error loading OCR text. Please try again later.
        </div>
      `;
    }
  });

  // Save functionality
  if (saveButton) {
    saveButton.addEventListener('click', async () => {
      const updatedContent = contentTextarea.value;

      try {
        const response = await fetch(`/active_storage/attachments/${currentAttachmentId}/ocr_text`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          },
          body: JSON.stringify({ content: updatedContent })
        });

        if (response.ok) {
          // Visual feedback
          const originalHTML = saveButton.innerHTML;
          saveButton.innerHTML = '<i class="fas fa-check me-1"></i> Saved!';

          setTimeout(() => {
            saveButton.innerHTML = originalHTML;
          }, 2000);
        } else {
          throw new Error('Failed to save OCR text');
        }
      } catch (error) {
        console.error('Error saving OCR text:', error);
        alert('Failed to save changes. Please try again.');
      }
    });
  }

  // Copy to clipboard functionality
  if (copyButton) {
    copyButton.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(contentTextarea.value);

        // Visual feedback
        const originalHTML = copyButton.innerHTML;
        copyButton.innerHTML = '<i class="fas fa-check me-1"></i> Copied!';
        copyButton.classList.remove('btn-primary');
        copyButton.classList.add('btn-success');

        setTimeout(() => {
          copyButton.innerHTML = originalHTML;
          copyButton.classList.remove('btn-success');
          copyButton.classList.add('btn-primary');
        }, 2000);
      } catch (error) {
        console.error('Failed to copy text:', error);
        alert('Failed to copy text to clipboard');
      }
    });
  }
});
